import { useRef, useEffect } from 'react';

/**
 * Moves focus to the referenced element on mount.
 * Used for route-change focus management (WCAG 2.1 §2.4.3).
 */
export default function useFocusOnMount() {
  const ref = useRef(null);
  useEffect(() => {
    ref.current?.focus({ preventScroll: true });
  }, []);
  return ref;
}
